import { render, staticRenderFns } from "./sub-top-image.vue?vue&type=template&id=6fdcdeaa&scoped=true&"
import script from "./sub-top-image.vue?vue&type=script&lang=js&"
export * from "./sub-top-image.vue?vue&type=script&lang=js&"
import style0 from "./sub-top-image.vue?vue&type=style&index=0&id=6fdcdeaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdcdeaa",
  null
  
)

export default component.exports